(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["error-life-style-split"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=scope=>{if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;(scope||document).querySelectorAll('.error-split:not([data-error-init])').forEach(box=>{box.dataset.errorInit='1';const panels=[...box.querySelectorAll('.error-split__panel')],hit=p=>{if(!p||p.classList.contains('is-glitch'))return;p.classList.add('is-glitch');setTimeout(()=>p.classList.remove('is-glitch'),190)};panels.forEach(p=>{p.addEventListener('mouseenter',()=>hit(p));p.addEventListener('focus',()=>hit(p))});const loop=()=>{const min=+box.dataset.min||4500,max=+box.dataset.max||9500;box._errorTimer=setTimeout(()=>{if(document.visibilityState==='visible')hit(panels[Math.floor(Math.random()*panels.length)]);loop()},Math.random()*(max-min)+min)};loop()})};document.readyState==='loading'?document.addEventListener('DOMContentLoaded',()=>init(document)):init(document);document.addEventListener('shopify:section:load',e=>init(e.target))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
